import { render, staticRenderFns } from "./biz-setting.vue?vue&type=template&id=5a3f1599&scoped=true&"
import script from "./biz-setting.vue?vue&type=script&lang=js&"
export * from "./biz-setting.vue?vue&type=script&lang=js&"
import style0 from "./biz-setting.vue?vue&type=style&index=0&id=5a3f1599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3f1599",
  null
  
)

export default component.exports